// import React from "react";
// import { useTranslation } from "react-i18next";

// function Disclaimer() {
//   const { t } = useTranslation();

//   return (
//     <div className="policy-page">
//       <h5>{t("Disclaimer.title")}</h5>

//       <p>{t("Disclaimer.content1")}</p>
//       <p>{t("Disclaimer.content2")}</p>
//       <p>{t("Disclaimer.content3")}</p>
//       <p>{t("Disclaimer.content4")}</p>
//       <p>{t("Disclaimer.content5")}</p>
//     </div>
//   );
// }

// export default Disclaimer;

import React from "react";

function Disclaimer() {
  return (
    <div className="container py-5">
      <div className="card shadow-sm border-0 rounded-3">
        <div className="card-body p-4 p-md-5">

          <h5 className="fw-bold text-success border-bottom pb-3 mb-4">
            Disclaimer
          </h5>

          <p
            className="text-secondary lh-lg mb-4"
            style={{ textIndent: "2.5rem" }}

          >
            This Website is designed & developed by Tamil Nadu State
            Warehousing Corporation and maintained by this department.
          </p>

          <p
            className="text-secondary lh-lg mb-4"
            style={{ textIndent: "2.5rem" }}
          >
            The contents of this website is provided for information purposes
            only, enabling the public at large to have a quick and an easy
            access to information and do not have any legal sanctity. Though
            every effort is made to provide accurate and updated information,
            it is likely that the same details such as telephone numbers,
            names of the officer holding a post, etc. may have changed prior
            to their update in the website. Hence, we do not assume any legal
            liability on the completeness, accuracy or usefulness of the
            contents provided in this website.
          </p>

          <p
            className="text-secondary lh-lg mb-4"
            style={{ textIndent: "2.5rem" }}
          >

            The links are provided to other external sites in some web pages/
            documents. We do not take responsibility for the accuracy of the
            contents in those sites. The hyperlink given to external sites do
            not constitute an endorsement of information, products or services
            offered by these sites.
          </p>

          <p
            className="text-secondary lh-lg mb-4"
            style={{ textIndent: "2.5rem" }}
          >
            Despite our best efforts, we do not guarantee that the documents
            in this site are free from infection by computer viruses etc.
          </p>

          <p
            className="text-secondary lh-lg mb-0"
            style={{ textIndent: "2.5rem" }}
          >
            We welcome your suggestions to improve this website and request
            that error (if any) may kindly be brought to our notice.
          </p>

        </div>
      </div>
    </div>
  );
};

export default Disclaimer;